import { lazy, Suspense } from "react";
import { HeroSection } from "@/components/landing/HeroSection";
import { Navbar } from "@/components/Navbar";
import { ComplianceDisclaimer } from "@/components/ComplianceDisclaimer";
import { PageSEO } from "@/components/PageSEO";

// Below-the-fold sections are code-split so they don't bloat the LCP bundle.
const ValueProp = lazy(() =>
  import("@/components/landing/ValueProp").then((m) => ({ default: m.ValueProp })),
);
const HowItWorks = lazy(() =>
  import("@/components/landing/HowItWorks").then((m) => ({ default: m.HowItWorks })),
);
const LegitimacyContent = lazy(() =>
  import("@/components/landing/LegitimacyContent").then((m) => ({
    default: m.LegitimacyContent,
  })),
);
const Footer = lazy(() =>
  import("@/components/landing/Footer").then((m) => ({ default: m.Footer })),
);

const SectionFallback = () => <div className="min-h-[400px]" aria-hidden />;

const Index = () => {
  return (
    <div className="min-h-screen bg-background overflow-x-hidden">
      <PageSEO
        title="TokDadddy — Social Media Growth Services"
        description="Grow your TikTok, YouTube, Spotify, Instagram and more. Fast, safe social media promotion. No password needed. USD pricing."
        path="/"
      />
      <Navbar />
      <main id="main">
        <div className="relative z-30">
          <HeroSection />
        </div>
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
          <ComplianceDisclaimer variant="compact" />
        </div>
        <div className="relative z-10">
          <Suspense fallback={<SectionFallback />}>
            <ValueProp />
            <HowItWorks />
            <LegitimacyContent />
          </Suspense>
        </div>
      </main>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
